const getHorizontalStep = (scroller, firstItem) => {
  if (!scroller) return 0;
  if (!firstItem) return scroller.clientWidth;

  const styles = window.getComputedStyle(scroller);
  const gap = parseFloat(styles.columnGap || styles.gap || "0");
  return firstItem.getBoundingClientRect().width + gap;
};

const updateHorizontalNavState = (scroller, prevButton, nextButton, edgeTolerance = 2) => {
  if (!scroller || !prevButton || !nextButton) return;

  const maxScrollLeft = Math.max(0, scroller.scrollWidth - scroller.clientWidth);
  const canScroll = maxScrollLeft > edgeTolerance;

  prevButton.hidden = !canScroll;
  nextButton.hidden = !canScroll;

  prevButton.disabled = !canScroll || scroller.scrollLeft <= edgeTolerance;
  nextButton.disabled = !canScroll || scroller.scrollLeft >= maxScrollLeft - edgeTolerance;
};

const attachDesktopMouseDrag = (
  scroller,
  {
    minWidth = 1024,
    dragClass = "is-dragging",
    imageSelector = "img",
    pointerType = "mouse",
    dragThreshold = 3,
  } = {}
) => {
  if (!scroller) return;

  let isDragging = false;
  let hasDragged = false;
  let pointerStartX = 0;
  let scrollStartX = 0;

  const isDesktopViewport = () => window.matchMedia(`(min-width: ${minWidth}px)`).matches;

  const stopDragging = () => {
    if (!isDragging) return;

    isDragging = false;
    scroller.classList.remove(dragClass);
  };

  const handlePointerDown = (event) => {
    if (event.pointerType !== pointerType || !isDesktopViewport() || event.button !== 0) return;

    event.preventDefault();

    isDragging = true;
    hasDragged = false;
    pointerStartX = event.clientX;
    scrollStartX = scroller.scrollLeft;
    scroller.classList.add(dragClass);

    if (scroller.setPointerCapture) {
      scroller.setPointerCapture(event.pointerId);
    }
  };

  const handlePointerMove = (event) => {
    if (!isDragging) return;

    event.preventDefault();

    const deltaX = event.clientX - pointerStartX;
    if (Math.abs(deltaX) > dragThreshold) {
      hasDragged = true;
    }

    scroller.scrollLeft = scrollStartX - deltaX;
  };

  const handleClickCapture = (event) => {
    if (!hasDragged) return;

    event.preventDefault();
    event.stopPropagation();
    hasDragged = false;
  };

  scroller.querySelectorAll(imageSelector).forEach((image) => {
    image.setAttribute("draggable", "false");
  });

  scroller.addEventListener("pointerdown", handlePointerDown);
  scroller.addEventListener("pointermove", handlePointerMove);
  scroller.addEventListener("pointerup", stopDragging);
  scroller.addEventListener("pointercancel", stopDragging);
  scroller.addEventListener("pointerleave", stopDragging);
  scroller.addEventListener("dragstart", (event) => event.preventDefault());
  scroller.addEventListener("click", handleClickCapture, true);
};

export { attachDesktopMouseDrag, getHorizontalStep, updateHorizontalNavState };
